// extracted by mini-css-extract-plugin
export var bb = "index-module--bb--2ff75 inline -tracking-[.5px]";
export var bottomRow = "index-module--bottomRow--ba35c grid grid-cols-1 lg_grid-cols-2 mt-12 lg_mt-32 items-start";
export var col = "index-module--col--184d2 col-span-6 lg_col-span-2 lg_text-end";
export var colSpace = "index-module--colSpace--88bd7 col-span-12 lg_col-span-4";
export var cont = "index-module--cont--373b0 index-module--cont--caa8c container mx-auto px-4";
export var copyrights = "index-module--copyrights--781a9 mt-12 text-sm";
export var fastlinks = "index-module--fastlinks--d505c";
export var footer = "index-module--footer--de07c block w-full bg-black text-white pb-20 pt-12";
export var footerSubTitle = "index-module--footerSubTitle--b4a70 text-base block whitespace-nowrap";
export var link = "index-module--link--32bcb text-sm uppercase";
export var linksTitle = "index-module--linksTitle--053d1 text-sm font-bold";
export var logoCol = "index-module--logoCol--19ac0";
export var mainCol = "index-module--mainCol--cc816 col-span-12 lg_col-span-4";
export var newsletterMessage = "index-module--newsletterMessage--8dec3 text-[22px] lg_text-[28px] block mb-8";
export var partnersCol = "index-module--partnersCol--5a2b6 flex mOnly_my-8 items-center justify-end gap-12";
export var row = "index-module--row--7f434 index-module--row--25056 grid gap-4 grid-cols-12";
export var spiCh = "index-module--spiCh--d23da font-bb";
export var svg = "index-module--svg--48bc6 w-full lg_max-w-md text-orange block mb-8";